module.exports = __webpack_public_path__ + "img/PRTG-logo.88ed7ea4.svg";